export default defineNuxtRouteMiddleware((to, from) => {
  // 判断路由是否存在
  // if (to.matched.length === 0) {
  //   console.log('路由未匹配到', to)

    // const locale = useComCookie('locale')
    // return navigateTo(`/${locale.value}/404`)
  // }
})
